import { includes } from 'lodash';
import { FIELD_PATH_SEPARATOR } from './referenceFieldPath';
export const isFieldReferencedOrNested = (fieldPath) => includes(fieldPath, FIELD_PATH_SEPARATOR);
//# sourceMappingURL=isFieldReferencedOrNested.js.map